import React from 'react';
import { Box, Switch, Text, FormLabel } from '@noom/wax-component-library';
export function SwitchSetting({ name, label, helper, isChecked, onChange, size, isDisabled, }) {
    const handleChange = () => {
        if (!isDisabled) {
            onChange(!isChecked);
        }
    };
    return (React.createElement(Box, { display: "flex", flexDir: "row", cursor: !isDisabled ? 'pointer' : 'auto' },
        React.createElement(Box, { display: "flex", flexDir: "column", flex: 1, mr: 2 },
            React.createElement(FormLabel, { htmlFor: name, m: 0, noOfLines: 1, title: typeof label === 'string' ? label : '' }, label),
            React.createElement(Text, { noOfLines: 2 }, helper)),
        React.createElement(Box, { display: "flex", alignItems: "center" },
            React.createElement(Switch, { size: size, name: name, onChange: handleChange, isChecked: isChecked, isDisabled: isDisabled, colorScheme: "primary" }))));
}
//# sourceMappingURL=SwitchSetting.js.map